/// <reference types="@angular/localize" />

import { platformBrowser } from '@angular/platform-browser'
import { provideZoneChangeDetection } from '@angular/core'
import { AppModule } from './app/app.module'
import { APP_CONFIG } from './app/app.config'
import { DataWebcamsService } from './app/shared/services/data-webcams.service'
import { DataProviderInfoService } from './app/shared/services/data-provider-info.service'

fetch('/config.json')
  .then(async (response) => await response.json())
  .then(async (config): Promise<void> => {
    platformBrowser([{ provide: APP_CONFIG, useValue: config }])
      .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
      .catch((err) => console.error(err))
  })

// Declare global variables here:
declare global {
  // Add map to the Window interface to use it in the cypress e2e tests
  interface Window {
    map: any
  }
}
